import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert } from "../../../utils";
import RoutesMap from "../../../route_control/RouteControl"

const jobPlace = (row) => {
    const issue = row?.itemIssue || {}
    return [issue?.subLocation?.name, issue?.location?.name, issue?.block?.block_name].filter(Boolean).join(' , ')
}

const mapMaintenanceJob = (row, type) => ({
    job_code: row?.job_code,
    asset_code: row?.assetDetail?.item_code || row?.asset_code,
    item_name: row?.assetDetail?.itemMaster?.name || row?.item_name,
    start_date: row?.start_date,
    status: row?.maintanance_status || row?.status,
    priority: row?.slaPriority?.name || row?.priority || '',
    location: jobPlace(row),
    person: row?.itemIssue?.staff?.staff_name || '',
    type,
})

const withPlace = (rows, lookup) => (rows || []).map(row => {
    const match = row.asset_code ? (lookup.get(`${row.job_code}|${row.asset_code}`) || {}) : (lookup.get(row.job_code) || {})
    return {
        ...row,
        location: row.location || match.location || '',
        person: row.person || match.person || '',
    }
})

export const maintenanceDashboardTodo = createAsyncThunk('maintenanceDashboard', async ({ navigate, from_date, to_date, location_id }) => {

    try {
        const headers = { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `dashboard/maintenance`,
            params: {
                from_date: from_date || undefined,
                to_date: to_date || undefined,
                location_id: location_id || undefined,
            },
            headers,

        })
        if (res?.status == 200) {
            try {
                const loadJobs = (maintanance_type) => axios({
                    method: 'GET',
                    url: process.env.REACT_APP_API_URL + `maintanance`,
                    params: {
                        pageSize: 200,
                        pageNo: 0,
                        maintanance_type,
                        search: '',
                    },
                    headers,
                })
                const [correctiveRes, preventiveRes] = await Promise.all([
                    loadJobs('corrective'),
                    loadJobs('preventive'),
                ])
                const corrective = correctiveRes?.status == 200 ? (correctiveRes.data?.data || []).map(row => mapMaintenanceJob(row, 'corrective')) : []
                const preventive = preventiveRes?.status == 200 ? (preventiveRes.data?.data || []).map(row => mapMaintenanceJob(row, 'preventive')) : []
                const lookup = new Map()
                ;[...preventive, ...corrective].forEach(row => {
                    if (row.job_code && row.asset_code) lookup.set(`${row.job_code}|${row.asset_code}`, row)
                    else if (row.job_code) lookup.set(row.job_code, row)
                })
                res.data.data = {
                    ...res.data.data,
                    overdue_jobs: withPlace(res.data.data?.overdue_jobs, lookup),
                    week_schedule: withPlace(res.data.data?.week_schedule, lookup),
                    corrective_jobs: corrective,
                }
            } catch (error) {
                res.data.data = { ...res.data.data, corrective_jobs: res.data.data?.corrective_jobs || [] }
            }
        }
        return res
    } catch (error) {
        return error.response
    }
})

const maintenanceDashboardSlice = createSlice({
    name: 'maintenanceDashboard',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(maintenanceDashboardTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                action?.meta?.arg?.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(maintenanceDashboardTodo.rejected, (state, action) => {
        })
    }
})

export default maintenanceDashboardSlice.reducer;
